import { render, staticRenderFns } from "./AncillaryReissueSearchLegHeader.vue?vue&type=template&id=0b64d934&scoped=true"
import script from "./AncillaryReissueSearchLegHeader.vue?vue&type=script&lang=js"
export * from "./AncillaryReissueSearchLegHeader.vue?vue&type=script&lang=js"
import style0 from "./AncillaryReissueSearchLegHeader.vue?vue&type=style&index=0&id=0b64d934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64d934",
  null
  
)

export default component.exports